import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, Collapse, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";

function Row({ row, index, header, subheader, subDataName, isLast }) {
    const [open, setOpen] = React.useState(false);

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell width={50} style={{ paddingBlock: '8px' }}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <Icon icon={'mdi:chevron-up'} className="font-size-16" /> : <Icon icon={'mdi:chevron-down'} className="font-size-16" />}
                    </IconButton>
                </TableCell>
                {
                    header.map((head, idx) => (
                        <TableCell component="th" scope="row" style={{ fontFamily: 'SophiaPro-Medium', paddingBlock: '8px', fontSize: 14 }}>
                            {head.accessor(row, index)}
                        </TableCell>
                    ))
                }
            </TableRow>
            <TableRow sx={{
                "& td": {
                    border: isLast && "none"
                }
            }}>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={(header?.length || 0) + 1}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1, paddingBlock: 2 }}>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        {
                                            subheader.map((subhead, idx) => (
                                                <TableCell style={{ fontWeight: 600, fontFamily: 'SophiaPro-Medium', color: '#808588' }}>{subhead.Header}</TableCell>
                                            ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row?.[subDataName]?.map((historyRow) => (
                                        <TableRow key={historyRow.date}>
                                            {
                                                subheader?.map((head, idx) => (
                                                    <TableCell component="th" scope="row" style={{ paddingBlock: 15, fontFamily: 'SophiaPro-Medium', }}>
                                                        {head.accessor(historyRow, index)}
                                                    </TableCell>
                                                ))
                                            }
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}


const CollapseTable = ({ header, data, subheader, subDataName, customRow, customRowBorderTop }) => {
    return (
        <TableContainer component={Paper} elevation={0}>
            <Table aria-label="collapsible table">
                <TableHead style={{ backgroundColor: '#F9F9F9' }}>
                    <TableRow>
                        <TableCell />
                        {
                            header.map((head, index) => (
                                <TableCell style={{ fontWeight: 600, fontFamily: 'SophiaPro-Bold', paddingBlock: 15, fontSize: 14 }}>{head.Header}</TableCell>
                            ))
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.length > 0 ? data.map((row, index) => (
                        <Row
                            key={row.name}
                            row={row}
                            index={index}
                            header={header}
                            subheader={subheader}
                            subDataName={subDataName}
                            isLast={index === data.length - 1}
                        />
                    )) : 
                    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                         <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={(header?.length || 0) + 1}>
                            <div className="d-flex align-items-center justify-content-center subheader-2" style={{ height: 200 }}>No data yet.</div>
                         </TableCell>
                    </TableRow>
                   
                    }
                    {customRow &&
                        <TableRow sx={{
                            border: "none", // Remove all borders except the top border for the last row
                            "& td": {
                                border: "none",
                                borderTop: "1px solid #101010" // Set the top border color to #101010
                            }
                        }}>
                            {
                                customRow.map((cell, idx) => (
                                    <TableCell
                                        colSpan={cell?.colSpan || 1}
                                        style={{ fontWeight: 600, fontFamily: 'SophiaPro-Medium', paddingBlock: 15, fontSize: 14, paddingInline: cell?.paddingInline, borderTop: customRowBorderTop?.borderTop || cell?.borderTop }}
                                    >
                                        {cell?.value}
                                    </TableCell>
                                ))
                            }
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}
export default CollapseTable;